import { render, staticRenderFns } from "./DocumentRegistry.vue?vue&type=template&id=5dc13cd0&scoped=true&"
import script from "./DocumentRegistry.vue?vue&type=script&lang=js&"
export * from "./DocumentRegistry.vue?vue&type=script&lang=js&"
import style0 from "./DocumentRegistry.vue?vue&type=style&index=0&id=5dc13cd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc13cd0",
  null
  
)

export default component.exports